import axios from 'axios'
import { i18n } from '../../plugins/i18n'
import { castAttributesForCamelCase, castAttributesForSnakeCase } from '../../modules/string_converter'

export const companiesMailReceivable = {
  namespaced: true,
  state: {
    loading: false,
    achievement: null,
    unreadNotificationWdays: null,
    keywordNotificationItemIds: null,
    wholeKeywords: [],
    blockGoogleUpdate: null
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    apiSuccess(state, payload) {
      state.wholeKeywords = payload.meta?.whole_keywords
      state.keywordNotificationItemIds = payload.data?.attributes?.keywords?.map(item => Number(item.id))
      state.unreadNotificationWdays = payload.data?.attributes?.unread_notification_wdays
      state.achievement = castAttributesForCamelCase(payload.data?.attributes?.achievement)
      state.blockGoogleUpdate = payload.data?.attributes?.block_google_update
      state.report = castAttributesForCamelCase(payload.data?.attributes?.report)
      state.custom_survey_store_answer = castAttributesForCamelCase(payload.data?.attributes?.custom_survey_store_answer)
      state.rpaError = castAttributesForCamelCase(payload.data?.attributes?.rpa_error)
      state.snsApproval = castAttributesForCamelCase(payload.data?.attributes?.sns_approval)
      state.postApproval = castAttributesForCamelCase(payload.data?.attributes?.post_approval)
      state.replyApproval = castAttributesForCamelCase(payload.data?.attributes?.reply_approval)
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    },
    subscribe(state) {
      state.unreadNotificationWdays = [1]
    },
    subscribeKeywordUsage(state, defaultKeyWordIds) {
      state.keywordNotificationItemIds = defaultKeyWordIds
    },
    unsubscribe(state) {
      state.unreadNotificationWdays = []
    },
    unsubscribeKeywordUsage(state) {
      state.keywordNotificationItemIds = []
    },
    changeSubscription(state, weekdayInt) {
      const notificationWdays = state.unreadNotificationWdays
      if (state.unreadNotificationWdays.includes(weekdayInt)) {
        state.unreadNotificationWdays = notificationWdays.filter(e => e !== weekdayInt)
      } else {
        notificationWdays.push(weekdayInt)
        notificationWdays.sort()
        state.unreadNotificationWdays = notificationWdays
      }
    },
    changeKeywordUsageSubscription(state, keywordId) {
      const notificationKeywordIds = state.keywordNotificationItemIds
      if (state.keywordNotificationItemIds.includes(keywordId)) {
        state.keywordNotificationItemIds = notificationKeywordIds.filter(e => e !== keywordId)
      } else {
        notificationKeywordIds.push(keywordId)
        notificationKeywordIds.sort()
        state.keywordNotificationItemIds = notificationKeywordIds
      }
    },
    subscribeBlockGoogleUpdate(state) {
      state.blockGoogleUpdate = true
    },
    unsubscribeBlockGoogleUpdate(state) {
      state.blockGoogleUpdate = false
    },
    subscribeReport(state) {
      state.report.subscribed = true
    },
    unsubscribeReport(state) {
      state.report.subscribed = false
    },
    subscribeCustomSurveyStoreAnswer(state) {
      state.custom_survey_store_answer.subscribed = true
    },
    unsubscribeCustomSurveyStoreAnswer(state) {
      state.custom_survey_store_answer.subscribed = false
    },
    subscribeRpaError(state) {
      state.rpaError.subscribed = true
    },
    unsubscribeRpaError(state) {
      state.rpaError.subscribed = false
    },
    subscribeSnsApproval(state) {
      state.snsApproval.subscribed = true
    },
    unsubscribeSnsApproval(state) {
      state.snsApproval.subscribed = false
    },
    subscribePostApproval(state) {
      state.postApproval.subscribed = true
    },
    unsubscribePostApproval(state) {
      state.postApproval.subscribed = false
    },
    subscribeReplyApproval(state) {
      state.replyApproval.subscribed = true
    },
    unsubscribeReplyApproval(state) {
      state.replyApproval.subscribed = false
    },
  },
  getters: {
    achievementKeys: () => [
      'insightActionBeyondLastMonthOnMonth',
      'insightActionBeyondLastYearOnYear',
      'totalReviewCount',
      'totalCustomSurveyAnswerCount',
      'reviewCountBeyondLastYear',
      'increaseReviewAverage',
    ],
    query: (state) => {
      return {
        mail_receivable: {
          unread_attributes: {
            unread_notification_wdays: state.unreadNotificationWdays,
          },
          receivable_keyword_ids: state.keywordNotificationItemIds,
          achievement_attributes: castAttributesForSnakeCase(state.achievement),
          block_google_update_attributes: {
            is_notice: state.blockGoogleUpdate
          },
          report_attributes: {
            subscribed: state.report.subscribed
          },
          custom_survey_store_answer_attributes: {
            subscribed: state.custom_survey_store_answer.subscribed
          },
          rpa_error_attributes: {
            subscribed: state.rpaError.subscribed
          },
          sns_approval_attributes: {
            subscribed: state.snsApproval.subscribed
          },
          post_approval_attributes: {
            subscribed: state.postApproval.subscribed
          },
          reply_approval_attributes: {
            subscribed: state.replyApproval.subscribed
          },
        }
      }
    },
    isSubscribedWday: (state) => (weekdayInt) => {
      return state.unreadNotificationWdays.includes(weekdayInt)
    },
    isSubscribedKeyword: (state) => (keywordId) => {
      return state.keywordNotificationItemIds.includes(keywordId)
    },
    unsubscribed: (state) => {
      return state.unreadNotificationWdays.length === 0
    },
    keywordUnsubscribed: (state) => {
      return state.keywordNotificationItemIds.length === 0
    }
  },
  actions: {
    readMailReceivable({ commit, state }, companyUuid) {
      if (state.loading) return

      commit('prepareConnect')

      return axios
        .get('/api/companies/' + companyUuid + '/mail_receivable.json')
        .then((res) => {
          commit('apiSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          if (err.response.status !== 404) {
            commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          }
          console.error(err)
        })
    },
    updateMailReceivable({ commit, state, getters }, companyUuid) {
      if (state.loading) return

      commit('prepareConnect')

      return axios
        .put('/api/companies/' + companyUuid + '/mail_receivable.json', getters.query)
        .then((res) => {
          commit('apiSuccess', res.data)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updatedInfo', { value: i18n.t('models.user.companyMailReceivable.modelName') }) }, { root: true })
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    subscribe({ commit }) {
      commit('subscribe')
    },
    unsubscribe({ commit }) {
      commit('unsubscribe')
    },
    subscribeKeywordUsage({ commit }, defaultKeyWordIds) {
      commit('subscribeKeywordUsage', defaultKeyWordIds)
    },
    unsubscribeKeywordUsage({ commit }) {
      commit('unsubscribeKeywordUsage')
    },
    changeSubscription({ commit }, weekdayInt) {
      commit('changeSubscription', weekdayInt)
    },
    changeKeywordUsageSubscription({ commit }, keywordId) {
      commit('changeKeywordUsageSubscription', keywordId)
    },
    subscribeBlockGoogleUpdate({ commit }) {
      commit('subscribeBlockGoogleUpdate')
    },
    unsubscribeBlockGoogleUpdate({ commit }) {
      commit('unsubscribeBlockGoogleUpdate')
    },
    subscribeReport({ commit }) {
      commit('subscribeReport')
    },
    unsubscribeReport({ commit }) {
      commit('unsubscribeReport')
    },
    subscribeCustomSurveyStoreAnswer({ commit }) {
      commit('subscribeCustomSurveyStoreAnswer')
    },
    unsubscribeCustomSurveyStoreAnswer({ commit }) {
      commit('unsubscribeCustomSurveyStoreAnswer')
    },
    subscribeRpaError({ commit }) {
      commit('subscribeRpaError')
    },
    unsubscribeRpaError({ commit }) {
      commit('unsubscribeRpaError')
    },
    subscribeSnsApproval({ commit }) {
      commit('subscribeSnsApproval')
    },
    unsubscribeSnsApproval({ commit }) {
      commit('unsubscribeSnsApproval')
    },
    subscribePostApproval({ commit }) {
      commit('subscribePostApproval')
    },
    unsubscribePostApproval({ commit }) {
      commit('unsubscribePostApproval')
    },
    subscribeReplyApproval({ commit }) {
      commit('subscribeReplyApproval')
    },
    unsubscribeReplyApproval({ commit }) {
      commit('unsubscribeReplyApproval')
    }
  },
}
